import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'prop-types';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconTemplate = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsxs(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("mask", {
      id: "Template_svg__a",
      fill: "#FFF",
      children: /*#__PURE__*/jsx("path", {
        d: "M12 3a1 1 0 110 2 1 1 0 010-2z"
      })
    }), /*#__PURE__*/jsx("path", {
      d: "M12 1.5a1.5 1.5 0 000 3v-3zm0 3a1.5 1.5 0 000-3v3zm0 0a.5.5 0 01-.278-.084L13.39 1.92A2.5 2.5 0 0012 1.5v3zm-.278-.084a.5.5 0 01-.184-.225l2.772-1.148a2.5 2.5 0 00-.921-1.122l-1.667 2.495zm-.184-.225a.5.5 0 01-.028-.289l2.942.586a2.5 2.5 0 00-.142-1.445l-2.772 1.148zm-.028-.289a.5.5 0 01.136-.256l2.122 2.122a2.5 2.5 0 00.684-1.28l-2.942-.586zm.136-.256a.5.5 0 01.256-.136l.586 2.942a2.5 2.5 0 001.28-.684l-2.122-2.122zm.256-.136a.5.5 0 01.29.028L11.042 6.31a2.5 2.5 0 001.445.142l-.585-2.942zm.29.028a.5.5 0 01.224.184L9.92 5.39a2.5 2.5 0 001.122.92l1.148-2.77zm.224.184A.5.5 0 0112.5 4h-3c0 .494.147.978.421 1.389l2.495-1.667zM12.5 4a.5.5 0 01-.146.354l-2.122-2.122A2.5 2.5 0 009.5 4h3zm-.146.354A.5.5 0 0112 4.5v-3a2.5 2.5 0 00-1.768.732l2.122 2.122z",
      fill: color,
      mask: "url(#Template_svg__a)"
    }), /*#__PURE__*/jsx("path", {
      d: "M6.75 10.5H12m3 0h2.25m0 3.75H12m-3 0H6.75m0 3.75H12m3 0h2.25m-1.5-13.5h3.75A1.5 1.5 0 0121 6v15.75a1.5 1.5 0 01-1.5 1.5h-15a1.5 1.5 0 01-1.5-1.5V6a1.5 1.5 0 011.5-1.5h3.75a3.75 3.75 0 017.5 0z",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
});
IconTemplate.displayName = "IconTemplate";

export { IconTemplate };
